/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_SecurityQuestionDto } from '../models/PagedResultDto_SecurityQuestionDto';
import type { Wealthlane_CustomerService_Dtos_SecurityQuestion_CreateUpdateSecurityQuestionDto } from '../models/Wealthlane_CustomerService_Dtos_SecurityQuestion_CreateUpdateSecurityQuestionDto';
import type { Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto } from '../models/Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SecurityQuestionService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppSecurityQuestionSecurityQuestions(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/security-question/security-questions',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param categoryId
     * @returns Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppSecurityQuestionSecurityQuestionsByCategory(
        categoryId: number,
    ): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/security-question/security-questions-by-category/{categoryId}',
            path: {
                'categoryId': categoryId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppSecurityQuestionSeedSecurityQuestions(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/security-question/seed-security-questions',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppSecurityQuestion(
        requestBody?: Wealthlane_CustomerService_Dtos_SecurityQuestion_CreateUpdateSecurityQuestionDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/security-question',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_SecurityQuestionDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppSecurityQuestion(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_SecurityQuestionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/security-question',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppSecurityQuestion(
        id: string,
        requestBody?: Wealthlane_CustomerService_Dtos_SecurityQuestion_CreateUpdateSecurityQuestionDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/security-question/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppSecurityQuestion(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/security-question/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppSecurityQuestion1(
        id: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_SecurityQuestion_SecurityQuestionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/security-question/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
